import React from 'react'

const LoadingView = (props) => {
  return <div className='initial-load-spinner' />
}

export default LoadingView
